<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vHx6qS/tc-custom/9780061850271.jpg?1737195673444" alt="This image is the cover for the book Don't Get Scrooged"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Don't Get Scrooged
      </h1>
      <p class="bookDescription body article font2">
        <p>Inside find helpful advice, such as:</p><p>Take a Vacation, Not a Guilt-Trip<br/><i>Don't Get "Should Upon"</i></p><p>Hades or Homecoming?<br/><i>Opt In- or Out-of Family Events</i></p><p><i>Quit Being Your Mother<br/>Ban Worry from Your Holidays</i></p><p>It's Not Daytona—You're Not Jeff Gordon<br/><i>Don't Try to Cook Tailgating Turkeys</i></p><p><i>Don't Get Scrooged</i> is a jewel of a handbook on how to avoid, appease, and even win over the Scrooges who haunt your holidays. Whether it's the salesclerk who ignores you in favor of her cell phone, the customer who knowingly jumps ahead of you in line at Starbucks, the unnaturally irritable boss down the hall, or the in-laws who invite themselves (every year) for a two-week stay at your house, you will always need to deal with Scrooges, grumps, uninvited guests, sticks-in-the-mud, and supreme party poopers. Learning to handle them whenever and wherever they appear is not just optional—it's essential.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard Carlson
      </h2>
      
      <p class="authorDescription body article"><P>Richard Carlson (1961-2006) is a bestselling author whose books include <I>Don't Sweat the Small Stuff . . . and It's All Small Stuff</I>; <I>Don't Worry, Make Money</I>; <I>You Can Feel Good Again</I>; and <I>You Can Be Happy No Matter What</I>. His books have been published in 35 languages in over 130 countries.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?17366615